export default "__VITE_ASSET__DxhsOc0c__"